import { ArchiveNodeOption } from "models/ArchiveNodeOption";
import "./UserServiceTreeItem.scss";

type Props = {
  service: ArchiveNodeOption;
  selectedNode: ArchiveNodeOption;
  onNodeClick: (
    service: ArchiveNodeOption,
    e: React.MouseEvent<HTMLElement, MouseEvent>
  ) => void;
};

export default function UserServiceTreeItem({
  service,
  selectedNode,
  onNodeClick
}: Props) {
  const getClasses = () => {
    const classes: string[] = [];
    const isExpanded =
      isChildSelected(service) || service.id === selectedNode.id;
    if (service.nodes.length === 0) {
      return "empty";
    }
    if (isExpanded) {
      classes.push("open");
    }
    if (selectedNode.id === service.id) {
      classes.push("selected");
    }

    if (isGrandparent()) {
      classes.push("folder");
    } else {
      classes.push("emptyFolder");
    }
    return selectedNode ? classes.join(" ") : "";
  };

  const isGrandparent = () => {
    return (
      service.nodes.length > 0 &&
      service.nodes.filter((n: ArchiveNodeOption) => n.nodes.length > 0)
        .length > 0
    );
  };

  const isChildSelected = (serviceItem: ArchiveNodeOption) => {
    for (const node of serviceItem.nodes) {
      if (selectedNode.id === node.id || isChildSelected(node)) {
        return true;
      }
    }
  };

  const createChildItem = () => {
    return service.nodes.map((node: ArchiveNodeOption) => {
      if (node.enabled || node.childEnabled) {
        return (
          <UserServiceTreeItem
            key={node.id}
            service={node}
            selectedNode={selectedNode}
            onNodeClick={onNodeClick}
          />
        );
      }
      return null;
    });
  };

  const children = service.nodes.length > 0 && <ul>{createChildItem()}</ul>;

  const me = (
    <a onClick={(e) => onNodeClick(service, e)}>
      <span>{service.name}</span>
    </a>
  );

  return (
    <li className={getClasses()}>
      {me}
      {children}
    </li>
  );
}
